import Button from "components/Button";
import Modal from "components/Modal";
import TextInputAuth from "components/TextInputAuth";
import React, { useState } from "react";
import Confirm from "icons/confirm-circle-white.svg";
import ArrowLeft from "icons/arrow-circle-left-green.svg";
import { ExportingChannel } from "services/manageFamilies";
import toastMessage from "helpers/handleToastMessage";
import { ToastContainer } from "react-toastify";
import { schemaEmails } from "./validation";
import handleErrors from "helpers/handleErrors";

type Props = {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  setShowEmail: React.Dispatch<React.SetStateAction<boolean>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setChannelId: React.Dispatch<React.SetStateAction<string>>;
  channelId: string;
};

const ModalExporting: React.FC<Props> = ({
  show,
  setShow,
  setShowEmail,
  setLoading,
  channelId,
  setChannelId,
}): JSX.Element => {
  const [email, setEmail] = useState("");
  const [reEmail, setReEmail] = useState("");
  const [errors, setErrors] = useState<any>();

  const exportConversations = async () => {
    try {
      setLoading(true);

      if (
        !schemaEmails.isValidSync({
          email,
          reEmail,
        })
      ) {
        handleErrors({
          schema: schemaEmails,
          stateData: {
            email,
            reEmail,
          },
          setErrorMessage: setErrors,
        });
        setLoading(false);
        return;
      }

      const { data } = await ExportingChannel(channelId, email);
      if (data) {
        setShowEmail(true);
        setShow(false);
      }
    } catch (error) {
      toastMessage({
        message: "Error, Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      children={
        <div className="w-full h-80 bg-bt-white p-6 rounded-md">
          <ToastContainer />
          <div className="flex flex-row items-center justify-center mt-4">
            <span
              className="font-nunito text-3xl text-bt-black mb-6"
              style={{
                fontStyle: "normal",
                fontWeight: 700,
              }}
            >
              Exporting Conversation History
            </span>
          </div>
          <div className="flex flex-row items-center justify-center">
            <span
              className="font-nunito font-light text-xl text-bt-black"
              style={{
                fontStyle: "normal",
                fontWeight: 300,
              }}
            >
              Please type the email address that will receive the full export
              log:
            </span>
          </div>

          <div className="flex flex-row items-center justify-center mt-4">
            <div className="flex flex-col w-1/2">
              <TextInputAuth
                label="Email address"
                placeholder={"Email address"}
                value={email}
                onChange={(e: any) => setEmail(e.target.value)}
                isHelp={errors?.email}
                helpText={errors?.email}
                onPaste={(e: any) => {
                  setErrors({ email: "Cannot paste email" });
                  e.preventDefault();
                  return false;
                }}
                onCopy={(e: any) => {
                  setErrors({ email: "Cannot copy email" });
                  e.preventDefault();
                  return false;
                }}
              />
            </div>
            <div className="flex flex-col w-1/2">
              <TextInputAuth
                label="Re-type email address"
                placeholder={"Re-type email address"}
                value={reEmail}
                onChange={(e: any) => setReEmail(e.target.value)}
                isHelp={errors?.reEmail}
                helpText={errors?.reEmail}
                onPaste={(e: any) => {
                  setErrors({ reEmail: "Cannot paste email" });
                  e.preventDefault();
                  return false;
                }}
                onCopy={(e: any) => {
                  setErrors({ reEmail: "Cannot copy email" });
                  e.preventDefault();
                  return false;
                }}
              />
            </div>
          </div>
          <div className="flex flex-row justify-around mt-4 mb-10">
            <div className="flex flex-col">
              <Button
                label={"Back"}
                iconLeft={ArrowLeft}
                className="bg-bt-white text-bt-green border border-bt-green h-10 w-28 font-sora rounded-full"
                onClick={() => {
                  setChannelId("");
                  setShow(false);
                }}
              />
            </div>
            <div className="flex flex-col">
              <Button
                label={"Confirm"}
                iconLeft={Confirm}
                className="bg-bt-green text-bt-white h-10 w-28 font-sora rounded-full"
                onClick={exportConversations}
              />
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ModalExporting;
